import React, { Component } from "react";
import { Icon } from "antd";
import PropTypes from "prop-types";
import styles from "./VisualitzacioContainerMenu.module.css";

class VisualitzacioContainerMenu extends Component {
  handleOnclick = () => {
    this.props.onClickPlegarDesplegar();
  };

  render() {
    const { plegat } = this.props;
    const classNameMenucontainer = plegat
      ? styles.MenuContainerPlegat
      : styles.MenuContainer;

    return (
      <div className={classNameMenucontainer}>
        <div
          className={styles.MenuContainerToggle}
          onClick={this.handleOnclick}
        >
          <Icon
            type={plegat ? "caret-right" : "caret-left"}
            className={styles.MenuContainerIcon}
          />
        </div>
        <div
          className={
            plegat ? (
              styles.MenuContainerContentPlegat
            ) : (
              styles.MenuContainerContentDesplegat
            )
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

VisualitzacioContainerMenu.propTypes = {
  plegat: PropTypes.bool,
  onClickPlegarDesplegar: PropTypes.func
};

export default VisualitzacioContainerMenu;
